export default function Spelling1() {
  return (
    <table className="table_sticky" style={{ textAlign: "center" }}>
      <tbody>
        <tr>
          <th /> <th> e ě </th>
          <th> ę ų </th>
          <th> č š ž </th>
          <th> g </th>
          <th> h </th>
          <th> v </th>
          <th> l lj </th>
          <th> nj </th>
        </tr>
        <tr>
          <th>Polish-based</th>
          <td> ie </td>
          <td> ię ą </td>
          <td> cz sz ż </td>
          <td> g </td>
          <td> ch </td>
          <td> w </td>
          <td> ł l </td>
          <td> ń/ni </td>
        </tr>
        <tr>
          <th>Czech/Slovak-based</th>
          <td> e ě </td>
          <td> ia u </td>
          <td> č š ž </td>
          <td> h </td>
          <td> ch </td>
          <td> v </td>
          <td> l ľ </td>
          <td> ň </td>
        </tr>
        <tr>
          <th>Croatian-based</th>
          <td> e je </td>
          <td> e u </td>
          <td> č š ž </td>
          <td> g </td>
          <td> h </td>
          <td> v </td>
          <td> l lj </td>
          <td> nj </td>
        </tr>
      </tbody>
    </table>
  )
}
